import { render } from "./WidgetCheckRevisions.vue?vue&type=template&id=5744ca82&scoped=true"
import script from "./WidgetCheckRevisions.vue?vue&type=script&lang=js"
export * from "./WidgetCheckRevisions.vue?vue&type=script&lang=js"

import "./WidgetCheckRevisions.vue?vue&type=style&index=0&id=5744ca82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5744ca82"]])

export default __exports__